import {
  defaultLoadableState,
  LoadableState,
  useLoadableState
} from '@carvana/merch-react-hooks';
import React, { createContext, useMemo, useContext } from 'react';
import { useFavoriteIds } from '~/context/common/UserContext';
import { BffVehicle } from '~/contracts/home';

type RecentVehiclesContextType = {
  recentVehicles: LoadableState<BffVehicle[]>;
};

const defaultContext: RecentVehiclesContextType = {
  recentVehicles: defaultLoadableState<BffVehicle[]>([])
};

const RecentVehiclesContext =
  createContext<RecentVehiclesContextType>(defaultContext);

export type OwnProps = React.PropsWithChildren<{
  recentVehicles: BffVehicle[];
}>;

export function RecentVehiclesContextProvider(props: OwnProps) {
  const recentVehicles = useLoadableState<BffVehicle[]>(props.recentVehicles);

  const value = useMemo<RecentVehiclesContextType>(
    () => ({
      recentVehicles
    }),
    [recentVehicles]
  );

  return (
    <RecentVehiclesContext.Provider value={value}>
      {props.children}
    </RecentVehiclesContext.Provider>
  );
}

export function useGetRecentVehiclesWithFavorites(): BffVehicle[] {
  const favoriteIds = useFavoriteIds();
  const recentVehicles = useContext(RecentVehiclesContext).recentVehicles.data;

  return useMemo<BffVehicle[]>(
    () =>
      recentVehicles.map(vehicle => ({
        ...vehicle,
        isFavorited: favoriteIds.includes(vehicle.id)
      })),
    [favoriteIds, recentVehicles]
  );
}

export default RecentVehiclesContext;
